import { DeviceTreeNode, FolderDeviceTreeNode } from "@/model/data/deviceTree/DeviceTreeNode";
import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";

export default {
    totalDevicesInTree: (state) => {
        let deviceCounter = function (array) {
            let result = 0;
            array.forEach((element) => {
                if (element.type == DeviceTreeNodeTypeEnum.Device) {
                    result++;
                } else {
                    result = result + deviceCounter(element.children);
                }
            });
            return result;
        };
        return deviceCounter(state.deviceTree);
    },

    folderTree: (state) => {
        let foderTreeContent: FolderDeviceTreeNode[] = [];
        let addNode = function (node: FolderDeviceTreeNode, parentId: number) {
            if (parentId != null) {
                let checkNode = (d: FolderDeviceTreeNode) => {
                    if (d.id == parentId) d.children.push(node);
                    else if (d.children && d.children.length > 0) d.children.forEach(checkNode);
                };
                foderTreeContent.forEach(checkNode);
            } else {
                foderTreeContent.push(node);
            }
        };
        let deviceTreeFilter = function (node: DeviceTreeNode, parentId: number) {
            if (node.type == DeviceTreeNodeTypeEnum.Folder) {
                let tempNode: FolderDeviceTreeNode = new FolderDeviceTreeNode(null);
                tempNode.id = Number(node.id);
                tempNode.name = node.name;
                tempNode.type = node.type;
                tempNode.children = Array();

                addNode(tempNode, parentId);

                if ((node as FolderDeviceTreeNode).children) {
                    (node as FolderDeviceTreeNode).children.forEach((child) => {
                        deviceTreeFilter(child, Number(node.id));
                    });
                }
            }
        };
        state.deviceTree.forEach((root) => {
            deviceTreeFilter(root, null);
        });
        return foderTreeContent;
    },

    folderNames: (state) => {
        let folderNames: string[] = [];
        let deviceTreeFilter = function (node: DeviceTreeNode) {
            if (node.type == DeviceTreeNodeTypeEnum.Folder) {
                folderNames.push(node.name);

                if ((node as FolderDeviceTreeNode).children) {
                    (node as FolderDeviceTreeNode).children.forEach((child) => {
                        deviceTreeFilter(child);
                    });
                }
            }
        };
        state.deviceTree.forEach((root) => {
            deviceTreeFilter(root);
        });
        return folderNames;
    },

    installationNames: (state) => {
        let installationNames: string[] = [];
        let deviceTreeFilter = function (node: DeviceTreeNode) {
            if (node.type == DeviceTreeNodeTypeEnum.Device) {
                installationNames.push(node.name);
            } else if ((node as FolderDeviceTreeNode).children) {
                (node as FolderDeviceTreeNode).children.forEach((child) => {
                    deviceTreeFilter(child);
                });
            }
        };
        state.deviceTree.forEach((root) => {
            deviceTreeFilter(root);
        });
        return installationNames;
    },

    folderIdsAndNames: (state) => {
        let folderIdsAndNames = [];
        let deviceTreeFilter = function (node: DeviceTreeNode) {
            if (node.type == DeviceTreeNodeTypeEnum.Folder) {
                folderIdsAndNames.push({ name: node.name, id: +node.id });

                if ((node as FolderDeviceTreeNode).children) {
                    (node as FolderDeviceTreeNode).children.forEach((child) => {
                        deviceTreeFilter(child);
                    });
                }
            }
        };
        state.deviceTree.forEach((root) => {
            deviceTreeFilter(root);
        });
        return folderIdsAndNames;
    },

    rootFoldersIds: (state) => {
        let result = [];
        state.deviceTree.forEach((root: DeviceTreeNode) => {
            result.push(Number(root.id));
        });
        return result;
    },
};
